import { render } from "./BienDetailsPage.vue?vue&type=template&id=56231a54"
import script from "./BienDetailsPage.vue?vue&type=script&lang=js"
export * from "./BienDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__